import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/shared/Primitives";
import { Shield, Smartphone, KeyRound, Laptop } from "lucide-react";

export const Route = createFileRoute("/portal/security")({
  component: Security,
});

function Security() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Account security"
        description="Password, two-factor authentication, and active sessions."
      />
      <div className="grid gap-4 lg:grid-cols-2">
        {[
          {
            icon: KeyRound,
            title: "Password",
            desc: "Last changed 3 months ago",
            action: "Change",
          },
          {
            icon: Smartphone,
            title: "Two-factor auth",
            desc: "SMS to +91 ••••• 13371",
            action: "Manage",
          },
          {
            icon: Shield,
            title: "Recovery email",
            desc: "aarav.backup@gmail.com",
            action: "Update",
          },
          {
            icon: Laptop,
            title: "Active sessions",
            desc: "3 devices signed in",
            action: "Review",
          },
        ].map((c) => (
          <div
            key={c.title}
            className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5 shadow-elegant"
          >
            <div className="grid h-11 w-11 place-items-center rounded-xl bg-gradient-primary/10 text-primary">
              <c.icon className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <div className="text-sm font-semibold">{c.title}</div>
              <div className="text-xs text-muted-foreground">{c.desc}</div>
            </div>
            <button className="h-9 rounded-lg border border-border px-3 text-xs font-medium hover:bg-muted">
              {c.action}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
